import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pass-reset',
  templateUrl: './pass-reset.component.html',
  styleUrls: ['./pass-reset.component.scss']
})
export class PassResetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
